import React, { useEffect, useState } from 'react';
import './Modal.css';

const HowItWorksContent = ({ onClose }) => {
  const [searchState, setSearchState] = useState('idle'); // idle, typing, searching, complete
  const [exampleText, setExampleText] = useState('');
  const targetText = 'madeincookware.com';

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') onClose();
    };
    
    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [onClose]);

  useEffect(() => {
    let timeout;
    
    const startAnimation = () => {
      // Reset state
      setSearchState('idle');
      setExampleText('');
      
      // Start typing after a delay
      timeout = setTimeout(() => {
        setSearchState('typing');
        let currentIndex = 0;
        
        const typeInterval = setInterval(() => {
          if (currentIndex <= targetText.length) {
            setExampleText(targetText.slice(0, currentIndex));
            currentIndex++;
          } else {
            clearInterval(typeInterval);
            setSearchState('searching');
            
            // Show searching state for a moment
            setTimeout(() => {
              setSearchState('complete');
            }, 1500);
            
            // Reset animation after completion
            setTimeout(() => {
              startAnimation();
            }, 4000);
          }
        }, 100);
      }, 1000);
    };

    startAnimation();
    
    return () => {
      clearTimeout(timeout);
    };
  }, []);

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-container" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>How It Works</h2>
          <button className="close-button" onClick={onClose}>
            <i className="fas fa-times"></i>
          </button>
        </div>

        <div className="modal-content">
          <div className="simple-modal">
            <div className="example-search">
              <div className={`example-search-bar ${searchState}`}>
                <i className={`fas ${
                  searchState === 'searching' ? 'fa-spinner fa-spin' : 
                  searchState === 'complete' ? 'fa-check' : 'fa-search'
                }`}></i>
                <span className="example-text">{exampleText || '\u00A0'}</span>
                <button className={`example-button ${
                  searchState === 'complete' ? 'success' : 
                  searchState === 'searching' ? 'searching' : ''
                }`}>
                  {searchState === 'searching' ? 'Searching...' : 
                   searchState === 'complete' ? 'Found!' : 'Find'}
                </button>
              </div>
            </div>

            <div className="info-grid">
              <div className="info-card">
                <div className="card-icon">
                  <i className="fas fa-bolt"></i>
                </div>
                <h4>Fast Search</h4>
                <p>Get results in seconds</p>
              </div>

              <div className="info-card">
                <div className="card-icon">
                  <i className="fas fa-search"></i>
                </div>
                <h4>Search Results</h4>
                <p>Find specific products and stores</p>
              </div>

              <div className="info-card">
                <div className="card-icon">
                  <i className="fas fa-file-upload"></i>
                </div>
                <h4>Bulk Search</h4>
                <p>Search multiple stores at once</p>
              </div>

              <div className="info-card">
                <div className="card-icon">
                  <i className="fas fa-download"></i>
                </div>
                <h4>Export</h4>
                <p>Save results for later</p>
              </div>
            </div>

            <div className="notice-box">
              <div className="notice-icon">
                <i className="fas fa-exclamation-circle"></i>
              </div>
              <p>Note: Shipping costs may still apply to free products</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HowItWorksContent; 